module.exports = __webpack_public_path__ + "img/img3_8.61384fbc.jpeg";